export enum DialogModeType {
  ERROR = 0,
  INFO = 1
}
